import { render, staticRenderFns } from "./emailattachment.vue?vue&type=template&id=9f0457aa"
import script from "./emailattachment.vue?vue&type=script&lang=js"
export * from "./emailattachment.vue?vue&type=script&lang=js"
import style0 from "./emailattachment.vue?vue&type=style&index=0&id=9f0457aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports